import React, { Suspense } from "react";
import {ContextMenuManager, ContextMenuType} from "./ContextMenuManager";


import {ItemContextMenu} from "./ItemContextMenu/ItemContextMenu";
import {WorkspaceContextMenu} from "./WorkspaceContextMenu/WorkspaceContextMenu";
import {AddToClusterContextMenu} from "./AddToClusterContextMenu/AddToClusterContextMenu";
import {DocumentContextMenu} from "./DocumentContextMenu/DocumentContextMenu";
import {SelectOptions} from '../../components/form/Select/SelectOptions';
import {CalendarSelectOptions} from "../../components/form/CalendarSelect/CalendarSelectOptions";
import {CalendarSelectRepeatOptions} from "../../components/form/CalendarSelect/CalendarSelectRepeatOptions";
import {AvatarUploadContextMenu} from "./AvatarUploadContextMenu/AvatarUploadContextMenu";
import {NotificationPanel} from "./NotificationPanel";
import {AcknowledgmentContextMenu} from "./AcknowledgmentContextMenu/AcknowledgmentContextMenu";
import {AvatarGroupUsersContextMenu} from "./AvatarGroupUsersContextMenu/AvatarGroupUsersContextMenu";
import {
    AccessRoleLocationsContextMenu,
    AccessRoleMembersContextMenu
} from "./AccessRoleGroupContextMenu/AccessRoleGroupContextMenu";
import {AccessRoleRowOptions} from "./AccessRoleRowOptions/AccessRoleRowOptions";
import {AuditRowOptions} from "./AuditRowOptions/AuditRowOptions";
import {AuditProgressRowOptions} from "./AuditProgressRowOptions/AuditProgressRowOptions";
import {AuditQuestionOptions} from "./AuditQuestionOptions/AuditQuestionOptions";
import {IssueRowOptions} from "./IssueRowOptions/IssueRowOptions";
import {TreeQuickActionsContextMenu} from "./TreeQuickActionsContextMenu/TreeQuickActionsContextMenu";
import {ProfileContextMenu} from "./ProfileContextMenu/ProfileContextMenu";
import {TreeViewOptions} from "./TreeViewOptions/TreeViewOptions";
import {TreeHeaderOptions} from "./TreeHeaderOptions/TreeHeaderOptions";
import {LibraryRowOptions} from "./LibraryRowOptions/LibraryRowOptions";
import {WsMemberRowOptions} from "./WsMemberRowOptions/WsMemberRowOptions";
import { TreeSelectDropdownMenu } from "../../components/TreeSelectDropdown/TreeSelectDropdownMenu";

import {SectionSelectOptions} from "./SectionSelectOptions/SectionSelectOptions";


const TextToolbar = React.lazy(() => import("./editor/TextToolbar/TextToolbar").then(m => ({default: m.TextToolbar})));
const TriggerToolbar = React.lazy(() => import("./editor/TriggerToolbar/TriggerToolbar").then(m => ({default: m.TriggerToolbar})));
const TableToolbar = React.lazy(() => import("./editor/TableToolbar/TableToolbar").then(m => ({default: m.TableToolbar})));
const ImageToolbar = React.lazy(() => import("./editor/ImageToolbar/ImageToolbar").then(m => ({default: m.ImageToolbar})));
const EmbedToolbar = React.lazy(() => import("./editor/EmbedToolbar/EmbedToolbar").then(m => ({default: m.EmbedToolbar})));
const CalloutToolbar = React.lazy(() => import("./editor/CalloutToolbar/CalloutToolbar").then(m => ({default: m.CalloutToolbar})));
const LinkInContextEditBar = React.lazy(() => import("./editor/LinkInContextEditBar/LinkInContextEditBar").then(m => ({default: m.LinkInContextEditBar})));
const PlusToolbar = React.lazy(() => import("./editor/PlusToolbar/PlusToolbar").then(m => ({default: m.PlusToolbar})));


export const MainContextMenuManager = () => {
    return (
        <ContextMenuManager renderContextMenu={renderContextMenu}/>
    );
}


function renderContextMenu(type: ContextMenuType, params: any, handleClose: any, isDark?: boolean) {
    switch (type) {
        case 'item':
            return <ItemContextMenu {...params} handleClose={handleClose}/>;
        case 'avatar':
            return <AvatarUploadContextMenu {...params} handleClose={handleClose} isDark={isDark}/>
        case 'document':
            return <DocumentContextMenu {...params} handleClose={handleClose}/>;
        case 'workspace':
            return <WorkspaceContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;

        case 'notification-centre':
            return <NotificationPanel/>
        case 'add-to-cluster':
            return <AddToClusterContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'editor-text':
            return (
                <Suspense fallback={null}>
                    <TextToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-trigger':
            return (
                <Suspense fallback={null}>
                    <TriggerToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-table':
            return (
                <Suspense fallback={null}>
                    <TableToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-image':
            return (
                <Suspense fallback={null}>
                    <ImageToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-callout':
            return (
                <Suspense fallback={null}>
                    <CalloutToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-embed':
            return (
                <Suspense fallback={null}>
                    <EmbedToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-link':
            return (
                <Suspense fallback={null}>
                    <LinkInContextEditBar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-plus':
            return (
                <Suspense fallback={null}>
                    <PlusToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'select-options':
            return <SelectOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'tree-select-dropdown':
            return <TreeSelectDropdownMenu {...params} handleClose={handleClose} isDark={isDark} />;
        case 'calendar-select-options':
            return <CalendarSelectOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'calendar-select-repeat-options':
            return <CalendarSelectRepeatOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'acknowledgments-overview':
            return <AcknowledgmentContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'avatar-group-users':
            return <AvatarGroupUsersContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'access-role-members':
            return <AccessRoleMembersContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'access-role-locations':
            return <AccessRoleLocationsContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'access-role-row-options':
            return <AccessRoleRowOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'audit-row-options':
            return <AuditRowOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'audit-progress-row-options':
            return <AuditProgressRowOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'audit-question-options':
            return <AuditQuestionOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'issue-row-options':
            return <IssueRowOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'tree-quick-actions':
            return <TreeQuickActionsContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'tree-header-options':
            return <TreeHeaderOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'library-row-options':
            return <LibraryRowOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'ws-member-row-options':
            return <WsMemberRowOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'section-select-options':
            return <SectionSelectOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'tree-view-options':
            return <TreeViewOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'profile':
            return <ProfileContextMenu {...params} handleClose={handleClose}/>;
        default:
            return null;
    }
}
